const useCases = [
  { icon: "ri-store-2-fill", text: "コンビニでの衝動買いだけ防ぎたい" },
  { icon: "ri-calendar-2-fill", text: "平日の夜だけ甘いものを制限したい" },
  { icon: "ri-time-fill", text: "曜日や時間帯を決めて使いたい" },
  { icon: "ri-repeat-fill", text: "週に何回までにしたい" },
  { icon: "ri-moon-clear-fill", text: "夜のお菓子だけを止めたい" },
];

const features = [
  { icon: "ri-map-pin-fill", label: "店舗単位" },
  { icon: "ri-time-fill", label: "時間帯" },
  { icon: "ri-calendar-check-fill", label: "曜日" },
  { icon: "ri-counter-fill", label: "回数" },
  { icon: "ri-restaurant-fill", label: "多様な品目" },
];

export default function FlexibleSection() {
  return (
    <section className="bg-[#FDF9F4] py-20 px-6">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-sm text-[#B07040] font-bold tracking-widest uppercase mb-3">FLEXIBLE</p>
          <h2 className="text-2xl md:text-3xl font-black text-[#1a1a1a] leading-tight">
            生活や人付き合いを壊さず、<br />
            <span className="text-[#B07040]">無理なく続けやすい設計</span>です
          </h2>
          <p className="text-[#666] mt-4 text-base">
            YAMEBIは、ただ一律に禁止するサービスではありません。<br />
            <strong className="text-[#1a1a1a]">生活に合わせて、無理のない形で設定できます。</strong>
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
          {useCases.map((item, i) => (
            <div key={i} className="flex items-center gap-4 bg-white rounded-xl p-4 border border-[#F0E8DE]">
              <div className="w-10 h-10 flex items-center justify-center bg-[#FEF0E0] rounded-xl flex-shrink-0">
                <i className={`${item.icon} text-xl text-[#E07040]`}></i>
              </div>
              <p className="text-[#1a1a1a] text-sm font-medium">{item.text}</p>
            </div>
          ))}
        </div>

        <div className="bg-white border border-[#E0E8E0] rounded-2xl p-6">
          <p className="text-[#555] text-sm mb-4 text-center">設定できる条件</p>
          <div className="flex justify-center gap-4 flex-wrap">
            {features.map((f, i) => (
              <div key={i} className="flex flex-col items-center gap-1.5">
                <div className="w-12 h-12 flex items-center justify-center bg-[#E8F8E8] rounded-xl">
                  <i className={`${f.icon} text-xl text-[#00A000]`}></i>
                </div>
                <span className="text-xs text-[#444] font-medium">{f.label}</span>
              </div>
            ))}
          </div>
          <p className="text-[#666] text-sm text-center mt-4 leading-relaxed">
            お菓子やジャンクフード、甘い飲み物、その他1000以上の飲食物の品目制限が可能。それに加えて<strong className="text-[#1a1a1a]">店舗・時間帯・曜日・回数</strong>などを調整しながら使えるため、日常に合わせて続けやすいのが特徴です。
          </p>
        </div>
      </div>
    </section>
  );
}
